
import PlatformLatestPostsCard from '@/components/social/PlatformLatestPostsCard.vue';
import { SOCIAL_PLATFORMS_METADATA } from '@/constants';
import InstagramSettingsCard from '@/components/instagram/InstagramSettingsCard.vue';
import InstagramLoginCard from '@/components/instagram/InstagramLoginCard.vue';
import { ProjectViewMixin } from '@/mixins/ProjectViewMixin';
import { Bot, InstagramPlatformData, SupportedPlatform } from 'ignite360-core';
import _merge from 'lodash.merge';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'project-social-platform-instagram',
  components: {
    InstagramLoginCard,
    InstagramSettingsCard,
    PlatformLatestPostsCard,
  },
})
export default class ProjectSocialPlatformInstagram extends mixins(ProjectViewMixin) {
  readonly instagramPlatform = SupportedPlatform.Instagram;

  get isPlatformConnected(): boolean {
    const meta = SOCIAL_PLATFORMS_METADATA.find((m) => m.value === SupportedPlatform.Instagram);
    return !!this.bot && !!meta?.isConnected?.(this.bot);
  }

  onConnect(data: Partial<InstagramPlatformData>) {
    const newBot: Bot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.Instagram]: data,
      },
    });
    this.$store.commit('bots/updateBot', newBot);
  }

  onDisconnect() {
    const newBot: Bot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.Instagram]: {
          pageId: '',
          pageName: '',
          pageAccessToken: '',
          businessAccountId: '',
        },
      },
    });
    this.$store.commit('bots/updateBot', newBot);
  }
}
